import React from 'react'

import BuildingExpenseForm from './BuildingExpenseForm'
import { useMessage } from '../../hooks/message'
import { HOUSE_EXPENSE_DETAIL } from '../../urls'
import { usePutRequest } from '../../hooks/request'

export default function BuildingExpenseUpdate({ onCancel, item }) {
    const [showMessage] = useMessage()
    const client = usePutRequest({ url: HOUSE_EXPENSE_DETAIL.replace('{id}', item.id) })

    async function onSubmit(data, action) {
        const { success, error } = await client.request({ data })
        if (success) {
            onCancel()
            action.resetForm()
        }
        if (error) showMessage(error?.data?.detail || 'Ошибка', 'is-danger')
    }

    return (
        <div>
            <h1 className="title has-text-centered is-capitalized">
                <b>Ўзгартириш</b>
            </h1>
            <BuildingExpenseForm loading={client.loading} initialValues={item} onCancel={onCancel} onSubmit={onSubmit} />
        </div>
    )
}
